"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LongTextBold = exports.CustomLongText = exports.SubtitleBold = exports.CustomSubtitle = exports.CustomTitle = void 0;
var react_1 = __importDefault(require("react"));
var index_css_1 = __importDefault(require("./index.css"));
function CustomTitle(_a) {
    var children = _a.children;
    return react_1.default.createElement("h1", { className: index_css_1.default.title }, children);
}
exports.CustomTitle = CustomTitle;
function CustomSubtitle(_a) {
    var children = _a.children;
    return react_1.default.createElement("h2", { className: index_css_1.default.subtitle }, children);
}
exports.CustomSubtitle = CustomSubtitle;
function SubtitleBold(_a) {
    var children = _a.children;
    return react_1.default.createElement("h2", { className: index_css_1.default["subtitle-bold"] }, children);
}
exports.SubtitleBold = SubtitleBold;
function CustomLongText(_a) {
    var children = _a.children;
    return react_1.default.createElement("p", { className: index_css_1.default["long-text"] }, children);
}
exports.CustomLongText = CustomLongText;
function LongTextBold(_a) {
    var children = _a.children;
    return react_1.default.createElement("p", { className: index_css_1.default["long-text-bold"] }, children);
}
exports.LongTextBold = LongTextBold;
